// extracted by mini-css-extract-plugin
module.exports = {"header__menu":"menu_header__menu__30HBT","menu__stripe":"menu_menu__stripe__3ylKj"};